import { mergeStyleSets, getTheme } from "@fluentui/react/lib/Styling";

const theme = getTheme();

const styles = mergeStyleSets({
  panelsContainer: {
    padding: "10px",
    overflow: "auto",
  },
  tabsListContainer: {
    backgroundColor: theme.palette.neutralLighterAlt,
  },
});
export { styles };
